import { PartialTranslation } from '../translations';

export const zh_CN: PartialTranslation = {
  newChat: '新建对话',
  search: '搜索',
  user: '用户',
  settings: '设置',
  language: '语言',
  getHelp: '获取帮助',
  viewAllPlans: '查看所有计划',
  learnMore: '了解更多',
  logOut: '退出登录',
  chooseLanguage: '选择语言',
  chooseYourPreferredLanguage: '选择您的首选语言',
  searchLanguages: '搜索语言...',
  autoDetect: '自动检测',
  noLanguagesFound: '未找到匹配的语言',
  askAnything: '询问任何问题',
  lawhelperAi: 'Lawhelper.ai',
  personal: '个人',
  freePlan: '免费计划',
  current: '当前',
  close: '关闭',
  archive: '归档',
  delete: '删除',
  confirmDelete: '确定要删除这个对话吗？',
  confirmArchive: '确定要归档这个对话吗？',
  deleteCannotUndo: '此操作无法撤销。',
  archiveCanFind: '归档后您可以在归档列表中找到它。',
  // 归档标签页
  chats: '对话',
  archived: '归档',
  restore: '恢复',
  noArchivedChats: '暂无归档对话',
  backToChats: '返回对话',
  // 资源面板
  resources: '资源',
  addResource: '添加资源',
  deleteResource: '删除资源',
  noMatchingResourcesFound: '未找到匹配的资源',
  noResourcesAvailable: '暂无可用资源',
  hideResources: '隐藏资源',
  showResources: '显示资源',
  closeResourcesPanel: '关闭资源面板',

  // 上传状态
  uploading: '正在上传 %{fileName}...',
  processing: '正在处理 %{fileName}...',
  uploadSuccess: '✓ %{fileName} 上传成功',
  uploadError: '✗ 上传失败: %{error}',

  // 聊天输入框
  typeMessage: '输入消息...',
  thinkingOptions: '思维选项',
  deleteFile: '删除文件',
  clearSelection: '清除选择',

  // 思考模式选项
  deepInsight: '深度洞察 · 表面分析',
  deepInsightDesc: '快速理解关键要点',
  deepExploration: '深度探索 · 全面分析',
  deepExplorationDesc: '多维度深入研究',
  deepDeconstruction: '深度解构 · 系统论证',
  deepDeconstructionDesc: '逐层递进分析',

  // 写作模式选项
  contractReview: '合同审查 · 风险识别',
  contractReviewDesc: '条款分析和合规检查',
  textPolish: '文本润色 · 专业表达',
  textPolishDesc: '语言优化和结构调整',
  legalDocuments: '法律文书 · 标准起草',
  legalDocumentsDesc: '专业法律文档写作',
  addAttachment: '添加附件',
  sendMessage: '发送消息',
  cancelRequest: '取消',

  // 认证相关
  login: '登录',
  register: '注册',
  welcomeBack: '欢迎使用 LawHelper',
  loginSubtitle: '您的AI法律研究助手',
  continueWithGoogle: '使用 Google 登录',
  continueWithMicrosoft: '使用 Microsoft 登录',
  continueWithWeChat: '微信登录',
  orContinueWith: '或者使用',
  emailTab: '邮箱',
  phoneTab: '手机号',
  emailPlaceholder: '请输入邮箱',
  phonePlaceholder: '请输入手机号',
  codePlaceholder: '请输入6位验证码',
  sending: '发送中...',
  verifying: '验证中...',
  verify: '验证',
  sendMagicLink: '发送登录链接',
  getVerificationCode: '获取验证码',
  resendCode: '重新发送',
  resendIn: '重新发送',
  magicLinkSent: '登录链接已发送到您的邮箱',
  magicLinkHint: '我们将向您的邮箱发送一个安全链接',
  otpSent: '验证码已发送',
  agreeToTerms: '继续即表示您同意',
  privacyPolicy: '隐私政策',
  termsOfService: '服务条款',
  and: '和',

  // AI工具面板
  library: '资料库',
  aiReview: 'AI审查',
  aiDraft: 'AI起草',
  smartAssistant: '智能文档助手',
  // templateFill: '模板填写', // Deprecated
  // formFill: '表单填写', // Deprecated

  // 知识库搜索
  enableKnowledgeSearch: '启用知识库搜索',
  knowledgeSearchDesc: 'AI 回答时优先从您的文档中搜索',
  clickToDisable: '点击关闭',
  clickToEnable: '点击开启',

  // 隐私相关
  privacyTitle: '您的隐私很重要',
  privacyIntro: '我们使用Cookie和类似技术为您提供最佳体验。您可以在下方自定义您的偏好。',
  essentialCookies: '必要Cookie',
  essentialDesc: '网站运行所必需',
  analyticsCookies: '分析Cookie',
  analyticsDesc: '帮助我们改进服务',
  marketingCookies: '营销Cookie',
  marketingDesc: '用于个性化内容',
  acceptAll: '全部接受',
  essentialOnly: '仅必要',
  customize: '自定义',
  savePreferences: '保存设置',
  back: '返回',
  readPrivacyPolicy: '阅读隐私政策',
  cookiePolicy: 'Cookie政策',
  gdprCompliance: 'GDPR（通用数据保护条例）',
  piplCompliance: '个人信息保护法',

  // 工具历史筛选
  filterAll: '全部',
  filterChat: '对话',
  filterReview: '审查',
  filterDraft: '起草',
  filterTemplate: '模板',
  filterForm: '表单',

  // AI 思考状态
  thinking: '思考中...',
  thinkingProcess: '思维过程',
  analyzingLegalLogic: '正在梳理法律逻辑...',
  lawhelperThinking: 'Lawhelper 正在思考...',
  serviceError: '服务异常',
  uploaded: '已上传',

  // 设置页面
  settingsGeneral: '常规',
  settingsNotifications: '通知',
  settingsAppearance: '外观',
  settingsProfile: '个人资料',
  settingsResponseNotifications: '响应通知',
  settingsResponseNotificationsDesc: 'AI 回复完成时收到通知',
  settingsColorMode: '颜色模式',
  settingsLight: '浅色',
  settingsDark: '深色',
  settingsSystem: '跟随系统',
  about: '关于',

  // 快速回答
  quickAnswer: '快速回答',
  quickAnswerDesc: '简单问题快速响应',


  // AI Reviewer
  reviewTitle: '文档审查',
  exitReview: '退出审查',
  uploadPrompt: '上传PDF文档开始审查',
  uploadButton: '选择文件',
  startChatConfig: '输入"审查这个文档"开始AI审查',
  reviewPlaceholder: '输入消息或"审查这个文档"...',
  analyzing: '正在审查...',
  reviewComplete: '审查完成',
  issuesFound: '发现了 %{count} 个问题',

  // AI Drafter
  draftTitle: '法律文书起草',
  draftPlaceholder: '在此编辑文书内容，或让 AI 帮您生成...',
  analyzingTemplate: '正在分析模板文件 %{name}...',
  templateAnalyzed: '✅ 模板 %{name} 分析完成！请告诉我您需要如何修改或填写这个模板。',
  templateAnalysisPrompt: '分析这个模板的关键条款',
  parsingFailed: '⚠️ 无法解析文件，但您仍可以描述您的需求，我会尽力帮助您。',
  generating: '正在生成...',
  generatedSuccess: '✅ 文书已生成！您可以在左侧编辑器中查看和修改。',

  // AI Drafter Welcome Section
  drafterWelcome: '欢迎使用 AI 文书起草助手',
  drafterYouCan: '您可以：',
  drafterUploadTemplate: '上传模板让 AI 分析',
  drafterDescribeNeeds: '描述您需要的文书类型',
  drafterLetAiHelp: '让 AI 帮您起草合同、协议等',
  drafterExamples: '示例：',
  drafterExampleRental: '"帮我起草一份房屋租赁合同"',
  drafterExampleLabor: '"根据模板填写劳动合同"',
  drafterInputPlaceholder: '描述您需要的文书...',
  drafterThinking: '思考中...',
  drafterHistoryTitle: '历史记录',
  drafterNoHistory: '暂无历史记录',
  drafterNewChat: '新建对话',
  drafterHistory: '历史记录',
  drafterRemoveAttachment: '移除附件',
  drafterLineHeight: '行高',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: '导出为 Word (.docx)',
  drafterExportPdf: '导出为 PDF',
  drafterSave: '保存文档',
  drafterDownload: '下载文档',
  drafterUndo: '撤销',
  drafterRedo: '重做',
  drafterBold: '加粗',
  drafterItalic: '斜体',
  drafterStrike: '删除线',
  drafterUnderline: '下划线',
  drafterHighlight: '高亮',
  drafterLink: '插入链接',
  drafterAlignLeft: '左对齐',
  drafterAlignCenter: '居中',
  drafterAlignRight: '右对齐',
  drafterAlignJustify: '两端对齐',
  drafterList: '列表',
  drafterBulletList: '项目符号列表',
  drafterOrderedList: '有序列表',
  drafterTaskList: '任务列表',
  drafterOpenResource: '打开资源面板',
  drafterStopGeneration: '停止生成',
  drafterAgentMode: 'Agent 模式已开启 | 点击切换到普通对话',
  drafterAgentModeOn: 'Agent 模式已开启 | 点击切换到普通对话',
  drafterAgentModeOff: '普通对话模式 | 点击切换到 Agent 模式',
  drafterUploadAttachment: '上传附件',
  drafterExit: '退出',
  drafterConfirm: '确认',
  drafterOpenLink: '打开链接',
  drafterDeleteLink: '删除链接',
  drafterQuote: '引用块',

  // Workflow UI
  workflowTitle: 'AI 工作流',
  workflowRunning: '执行中...',
  workflowReady: '准备就绪',
  workflowCompleted: '已完成',
  workflowStartFailed: '工作流启动失败',
  workflowExecutionFailed: '工作流执行失败',
  workflowInterrupted: '工作流已被中断',
  workflowProcessing: '处理中...',
  workflowStepsCompleted: '步骤已完成',
  workflowStepsTotal: '工作流已完成（%{count} 个步骤）',

  // Workflow Actions
  acceptChanges: '接受更改',
  rejectChanges: '拒绝更改',
  changesAccepted: '已接受更改',
  changesRejected: '已拒绝更改',
  stopWorkflow: '停止',
  restartWorkflow: '重新开始',
  startDrafting: '开始起草',
  interrupt: '中断',

  // Workflow Form Labels
  documentSubject: '文书主题 *',
  documentType: '文书类型',
  jurisdiction: '法域',
  specialRequirements: '特殊要求（可选）',
  clickStartDrafting: '点击"开始起草"启动工作流',

  // Document Types
  docTypeContract: '合同',
  docTypeAgreement: '协议',
  docTypeNotice: '通知',
  docTypeLetter: '函件',
  docTypePetition: '申请书',
  docTypeWill: '遗嘱',
  docTypePowerOfAttorney: '委托书',

  // Countries
  countryChina: '中国',
  countryUSA: '美国',
  countryGermany: '德国',
  countryJapan: '日本',
  countryFrance: '法国',
  countryUK: '英国',

  // Citation Verification
  citationVerified: '已验证',
  citationUnverified: '未验证',

  // Image Loading
  imageLoadFailed: '图片加载失败',

  // Smart Document Assistant
  smartDocTitle: '智能文档助手',
  smartDocChatTitle: 'AI文书起草助手',
  smartDocDropPrompt: '拖放 PDF 文件到这里',
  smartDocSelectFile: '选择文件',
  smartDocOr: '或',
  smartDocWelcomeTitle: '欢迎使用 AI 文书起草助手',
  smartDocWelcomeYouCan: '您可以：',
  smartDocUploadForAI: '上传模板让 AI 分析',
  smartDocDescribeDoc: '描述您需要的文书类型',
  smartDocLetAIDraft: '让 AI 帮您起草合同、协议等',
  smartDocExamples: '示例：',
  smartDocExampleRental: '"帮我起草一份房屋租赁合同"',
  smartDocExampleLabor: '"根据模板填写劳动合同"',
  smartDocInputPlaceholder: '描述您需要的文书...',
  smartDocRemoveAttachment: '移除附件',
  smartDocOpenResources: '打开资源面板',
  smartDocExit: '退出',

  // Review Workflow
  reviewStartFailed: '审查工作流启动失败',
  reviewFailed: '审查失败',
  reviewFoundIssues: '审查完成，共发现 %{count} 个问题。',
  cannotReadStream: '无法读取响应流',
  parseEventFailed: '解析工作流事件失败',
  errorPrefix: '错误',
  unknownError: '未知错误',
  file: '文件',
  loading: '加载中...',

  // Landing page translations
  tagline: 'AI 驱动的法律智能',
  heroTitle1: 'Legal AI',
  heroTitle2: '让法律变得简单',
  jurisdictionsLabel: '覆盖国家',
  accuracyLabel: '准确率',
  fasterLabel: '效率提升',
  availableLabel: '全天候',
  platformCapabilities: '核心功能',
  testimonialQuote: '"LawHelper 彻底改变了我们的法律工作方式。"',
  testimonialAuthor: '李律师',
  testimonialPosition: '知名律所合伙人',
  viewPricing: '查看定价',
  footerPricing: '定价',
  footerPrivacy: '隐私政策',
  footerTerms: '服务条款',
  footerContact: '联系我们',
  footerCopyright: '© 2024 LawHelper 版权所有',

  // 本地文件夹浏览器
  localFolders: '本地文件夹',
  selectLocalFolder: '选择本地文件夹',
  reselectFolder: '更换文件夹',
  addToContext: '发送到对话',
  saveFile: '保存',
  renameFile: '重命名',
  fileSaved: '文件保存成功',
  fileRenamed: '文件已重命名为 %{name}',
  browserNotSupported: '您的浏览器不支持本地文件夹访问',
  noFolderSelected: '选择本地文件夹以浏览文件',
  scanningFolder: '正在扫描文件夹...',
  selectFileToPreview: '选择一个文件来预览',
  aiAnalyze: 'AI 分析',

  // 新手引导
  onboardingWelcome: '欢迎使用 Lawhelper.ai',
  onboardingSkip: '跳过',
  onboardingNext: '下一步',
  onboardingPrev: '上一步',
  onboardingGetStarted: '开始使用',
  onboardingSlide1Title: 'AI 智能法律对话',
  onboardingSlide1Desc: '向 AI 提出任何法律问题，支持三种推理深度模式。可直接拖拽或上传 PDF / Word 文件，AI 将即时解读文档内容。',
  onboardingSlide2Title: '案件管理系统',
  onboardingSlide2Desc: '在「资料库」中按案件创建文件夹并上传文档。通过开关控制是否将文件夹中的内容纳入 AI 对话上下文，集中管理所有案件资料。',
  onboardingSlide3Title: '本地文件夹访问',
  onboardingSlide3Desc: '点击「选择本地文件夹」打开电脑中的任意目录。支持浏览文件树、预览内容、在线编辑与保存文本文件，并可一键将文件发送至 AI 对话。',
  onboardingSlide4Title: 'AI 文书起草与审查',
  onboardingSlide4Desc: 'AI 起草提供完整的富文本编辑器，可根据描述生成法律文书或填充模板。AI 审查则自动识别合同中的风险条款与合规问题。在对话中输入 @ 即可引用案件文件夹或本地目录中的文件。',
  onboardingGuide: '使用引导',
  mentionFiles: '引用文件',
};
